import { PaymentWorkflowState } from "@/store/PaymentWorkflow/state";

export class State extends PaymentWorkflowState {
  livePayPaymentUpdateStatusSuccess = false;
  livePayPaymentUpdateStatusError: Record<any, any> | null = null;
  livePayPaymentUpdateStatusLoading = false;
}
